/** Static copy for the invite. Edit here; avoid scattering strings in JSX. */

export const site = {
  title: "Sarah & Paul — May 6, 2026",
};

export const hero = {
  kicker: "Together with their families",
  names: "Sarah Hahn & Paul Pelayo",
  tagline: "invite you to celebrate their marriage",
  dateLine: "Wednesday, May 6, 2026",
  placeLine: "New York City",
  scrollCue: "Scroll",
};

/** Paths under `public/gallery/` — JPEGs are portrait 900×1350 (2:3) from build script. */
const GALLERY_COUNT = 13;

export const gallery = {
  heading: "Gallery",
  ariaLabel: "Photo gallery",
  prevLabel: "Previous photo",
  nextLabel: "Next photo",
  slidePickerLabel: "Choose a photo",
  slideLabel: "Photo",
  hint: "Swipe or use arrow keys to browse",
  imagePaths: Array.from(
    { length: GALLERY_COUNT },
    (_, i) => `/gallery/${String(i + 1).padStart(2, "0")}.jpg`
  ),
};

export const invitation = {
  heading: "Invitation",
  paragraphs: [
    "We are thrilled to share this joyful moment with you. After years of laughter, adventure, and quiet Sundays, we are ready to say our vows and begin the next chapter side by side.",
    "Your presence would mean the world to us as we make it official surrounded by the people we love most.",
  ],
};

export const whenWhere = {
  heading: "When & where",
  ceremonyLabel: "Ceremony",
  timeLine: "Time to be announced",
  venueName: "NYC City Hall — Manhattan Marriage Bureau",
  addressLines: ["141 Worth Street", "New York, NY 10013"],
  calendarCaption: "May 2026",
};

/** Sunday-first weeks; nulls are leading/trailing padding cells. */
export const calendarMay2026 = {
  highlightDay: 6,
  weeks: [
    [null, null, null, null, null, 1, 2],
    [3, 4, 5, 6, 7, 8, 9],
    [10, 11, 12, 13, 14, 15, 16],
    [17, 18, 19, 20, 21, 22, 23],
    [24, 25, 26, 27, 28, 29, 30],
    [31, null, null, null, null, null, null],
  ],
};

/** Weekend timeline (source: schedule.md). */
export const schedule = {
  heading: "Weekend schedule",
  days: [
    {
      dateLabel: "May 6, 2026",
      intro:
        "The morning will be the ceremony + photos near city hall and near our hotel @ Nine Orchard. Lunch will be in midtown. Dinner + nighttime will be in lower manhattan again.  We are planning a dim sum lunch the day after.",
      blocks: [
        {
          time: "8:45 AM – 10:00 AM",
          title: "Sarah + Paul w/ parents — City Hall ceremony",
          detail:
            "We are planning to do the ceremony in the morning @ City Hall. We will aim to get a timeslot hopefully around 9:00am but there is no guarantee that the ceremony will happen exactly at that moment. We are told to plan to be in/around city hall for 40 minutes to an hour and are only allowed four people with us in the actual ceremony.",
        },
        {
          time: "10:00 AM – 11:00 AM",
          title: "All family City Hall photos",
          detail:
            "A photographer will meet us once the ceremony is completed. We’ll meet the rest of our family members outside the iconic city hall doors. When we exit, our photographer will coordinate with you to throw some confetti for a photo moment. Afterwards, we plan to snap a few photos around city hall with the photographer. See here for sample photos from our photographer.",
        },
        {
          time: "11:00 AM – 12:00 PM",
          title: "Sarah + Paul photos near hotel",
          detail:
            "We also want photos near our hotel @ Nine Orchard Hotel, we plan to spend about an hour taking photographs here before heading uptown for lunch. These photos will be just Sarah and I but family is welcome to wait in the area or you all can make your way to lunch ahead of us.",
        },
        {
          time: "12:00 PM – 12:30 PM",
          title: "Travel uptown for lunch",
          detail: null,
        },
        {
          time: "12:30 PM – 2:30 PM",
          title: "Lunch",
          detail: "Lunch @ The Grill",
        },
        {
          time: "2:30 PM – 7:00 PM",
          title: "Break",
          detail:
            "Time set aside to check in to hotels/rest/regroup/have dinner. Sarah and I will be getting dinner by ourselves",
        },
        {
          time: "7:00 PM – 7:30 PM",
          title: "Setup @ Ripple Room",
          detail:
            "Meet @ The Ripple Room room to set up (pizza/cake being delivered). We will also get help from the bar to set some things up.",
        },
        {
          time: "7:30 PM – late",
          title: "Party/Bar",
          detail:
            "We have space booked out for 50 people @ The Ripple Room. We’ve invited friends to come celebrate with us. ",
        },
      ],
    },
    {
      dateLabel: "May 7, 2026",
      intro: null,
      blocks: [
        {
          time: "1:00 PM",
          title: "Dim Sum",
          detail: "We have a reservation for 11 @ Golden Unicorn.",
        },
      ],
    },
  ],
};

export const directions = {
  heading: "Getting there",
  intro:
    "The Manhattan Marriage Bureau is in Lower Manhattan, near City Hall and the courthouses.",
  bullets: [
    "Subway: J, Z, 4, 5, 6 to Brooklyn Bridge–City Hall; 2, 3 to Park Place; R, W to City Hall; A, C to Chambers Street — all within a short walk.",
    "If you are driving, street parking is limited; paid garages are nearby.",
  ],
  maps: {
    google:
      "https://www.google.com/maps/search/?api=1&query=Manhattan+Marriage+Bureau+141+Worth+St+New+York+NY+10013",
    apple:
      "https://maps.apple.com/?address=141%20Worth%20St,%20New%20York,%20NY%2010013",
  },
  mapLabels: {
    google: "Open in Google Maps",
    apple: "Open in Apple Maps",
  },
};

export const gifts = {
  heading: "Celebrate with us",
  intro:
    "Your love and good wishes are the greatest gift. If you would like to honor us in another way, a contribution toward our future together would be deeply appreciated.",
  emptyMessage:
    "We will share details here soon. Thank you for thinking of us.",
  registryKoreanLabel: "Korean cash registry",
  registryAmericanLabel: "American cash registry",
  koreanPlaceholder:
    "Korean bank account details will be shared here soon. Thank you for your patience.",
  americanZelleEmail: "paul.e.pelayo@gmail.com",
  americanZelleMailSubject: "Wedding gift",
  labels: {
    zelle: "Zelle",
    venmo: "Venmo",
    paypal: "PayPal",
    note: "Note",
  },
  copyLabel: "Copy details",
  copiedLabel: "Copied",
};
